export const REQUEST_CHANGEPASSWORDWEB = 'REQUEST_CHANGEPASSWORDWEB';
export const CHANGEPASSWORDWEB_RECEIVED = 'CHANGEPASSWORDWEB_RECEIVED';

